// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__2B4x8","pulse":"styles_pulse__CKQR7"};